import { Formula } from '@studio/domain';
import { decimal, toFixedDecimal } from '@studio/utils/utils';

export function serializeNumberOrFormula(
    value: number | string | Formula,
    allowFormulas: boolean = false,
    isHighPrecision = false
): number | string | Formula {
    if (typeof value === 'number') {
        return serializeNumber(value, isHighPrecision);
    } else if (typeof value === 'string' && allowFormulas) {
        return serializeFormula(value);
    }
    throw new Error('Unexpected number or formula value.');
}

export function serializeNumber(value: number, isHighPrecision = false): number {
    if (isHighPrecision) {
        return toFixedDecimal(value, 6);
    }
    return decimal(value as number);
}

function serializeFormula(value: string | Formula): string | Formula {
    if (value.indexOf('@') > -1) {
        return value;
    }
    throw new Error('Unexpected formula value.');
}
